import { US } from "./us";

export const CA = US;
